define([
	"dojo/_base/declare",
	"dijit/DialogUnderlay",
	"csi/action/ProxyController",
	"csi/widget/MessageDialog"
], function (declare, DialogUnderlay, ProxyController, MessageDialog) {

	return declare(ProxyController, {
		/**
		 * @override
		 *  always pop up a confirm dialog for this controller
		 */
		hasToConfirmAction: function () {
			return true;
		},

		process: function () {
			this.disableActionView(true);
			const acOrig = this.getOriginalController();

			// clear the queue
			acOrig._sourcesToCheck = [];

			acOrig.m_proxy = this;
			acOrig.resumeProcess();
			acOrig.postProcess();
		},

		/**
		 * @override
		 * handle the logic based on different choice
		 */
		onConfirm: function (key) {
			if (key == MessageDialog.BUTTON_CANCEL) {
				this.endProcess();
			} else {
				this.preProcess();
			}
		},

		/**
		 * @override
		 * config the dialog
		 */
		confirmAction: function (params) {
			params = params || {};
			params.materialIcon = MessageDialog.ICON_WARNING;
			params.buttons = [MessageDialog.BUTTON_CONTINUE, MessageDialog.BUTTON_CANCEL];
			params.title = this.getString("_Title");
			params.message = this.getString("_Confirm");

			// reset this so that the zIndex of the underlay can be adjusted, this property can be fixed in the next round anyway(closeDialog function)
			DialogUnderlay.setDisabled(false);

			this.inherited(arguments);
		}
	});
});